export const getScheduleAnalysesData = state => state.scheduleAnalyses.all;
export const getScheduleAnalysisData = state => state.scheduleAnalyses.scheduleAnalysis;
export const scheduleAnalysesIsFetching = state => state.scheduleAnalyses.loading.all;
export const scheduleAnalysisIsFetching = state => state.scheduleAnalyses.loading.scheduleAnalysis;
